import React, { useEffect, useState } from "react";
import { Container, Spinner } from "reactstrap";

// redux
import { shallowEqual, useDispatch, useSelector } from "react-redux";

// utils
import logger from "../../utils/logger";

// sayfalar, modallar vs.
import AdminDashboard from "./Admin";
import CompanyDashboard from "./Company";

const Dashboard = () => {
  document.title = "Ana Sayfa | Metiner Avantaj+";

  const dispatch = useDispatch();

  // states
  const [loading, setLoading] = useState(true);

  const { isUserData } = useSelector((state) => {
    return {
      isUserData: state.auth.isUserData,
    };
  }, shallowEqual);

  const fetchData = async () => {
    setLoading(true);

    try {
    } catch (error) {
      logger.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch]);

  if (loading || !isUserData) {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "50vh" }}
            >
              <Spinner color="primary">Yükleniyor...</Spinner>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }

  if (isUserData?.role == "Company") {
    return (
      <React.Fragment>
        <CompanyDashboard id={isUserData?.companyId} />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <AdminDashboard id={isUserData?.companyId} />
    </React.Fragment>
  );
};

export default Dashboard;
